// ErrorBoundary.js
import React, { useEffect } from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import errorBoundaryIcon from "../assets/svg/errorBoundaryIcon.svg";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll behavior
    });
  }, []);

  return (
    <div
      role="alert"
      className="d-flex flex-column justify-content-center align-items-center min-vh-100 bg262523 text-white"
    >
      <img
        className="errorBoundaryIcon"
        src={errorBoundaryIcon}
        alt="errorBoundaryIcon"
      />
      <b className="my-2">Looks like something went wrong</b>
      {/* <pre>{error.message}</pre> */}
      <button className="tryAgainButton" onClick={resetErrorBoundary}>
        Try again
      </button>
    </div>
  );
};

const ErrorBoundary = ({ children }) => (
  <ReactErrorBoundary FallbackComponent={ErrorFallback}>
    {children}
  </ReactErrorBoundary>
);

export default ErrorBoundary;
